export default __webpack_public_path__ + "static/media/T760_CoC.dbde9b68.pdf";